module.exports = __webpack_public_path__ + "static/media/93.a222a348.jpg";